import { Wrapper } from '../Wrapper';
import logo from '../../static/image/logo.png';

const goHomeAndReload = () => {
    window.location.replace('/');
};

export const ErrorFallback = () => (
    <div className="flex h-screen w-11/12 items-baseline md:w-5/12 md:items-center mx-auto">
        <Wrapper>
            <div className="flex items-center justify-center py-10">
                <div className="w-1/3">
                    <img src={logo} alt="Centro de Formación Académica" />
                </div>
            </div>

            <div className="mt-2 flex items-center justify-center">
                <div className="mx-auto w-10/12">
                    <h1 className="text-center text-3xl font-bold text-gray-950 sm:text-4xl">
                        Algo salió mal
                    </h1>
                </div>
            </div>
            <div className="mt-4 flex items-center justify-center">
                <div className="mx-auto w-10/12">
                    <p className="text-center text-sm font-normal text-gray-600 md:text-md">
                        No pudimos mostrar esta pantalla. Vuelve al inicio para recargar la aplicación y continuar.
                    </p>
                </div>
            </div>
            <div className="mt-8 flex w-full justify-center md:w-10/12 mx-auto">
                <button
                    type="button"
                    onClick={goHomeAndReload}
                    className="rounded-lg bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
                >
                    Ir al inicio
                    <span className="ml-3" aria-hidden="true">
                        &rarr;
                    </span>
                </button>
            </div>
        </Wrapper>
    </div>
);
